import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutMe } from './components/AboutMe';
import { WhoIHelp } from './components/WhoIHelp';
import { Approach } from './components/Approach';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { BrandAssets } from './components/BrandAssets';
export function App() {
  const [hash, setHash] = useState(typeof window !== 'undefined' ? window.location.hash : '');
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  if (hash === '#brand-assets') {
    return <BrandAssets data-id="element-0" />;
  }
  return <div className="min-h-screen bg-offwhite-50 font-sans selection:bg-amber-500/30 selection:text-charcoal-950" data-id="element-1">
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <AboutMe data-id="element-5" />
        <WhoIHelp data-id="element-6" />
        <Approach data-id="element-7" />
        <Services data-id="element-8" />
        <Testimonials data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}